import { FunctionComponent } from 'react';
import NextImage from 'next/image';

import { getAssetPath } from 'utils/assetPath';

import { Props } from './types';

const LayoutImage: FunctionComponent<Props> = (props) => {
    const correctedProps = {
        ...props,
        src: typeof props.src === 'string' ? getAssetPath(props.src) : props.src,
    };

    return <NextImage {...correctedProps} />;
};

export default LayoutImage;